export const CHIP_GAP_PX = 4;
export const OVERFLOW_CHIP_RESERVE_PX = 40;
export const CHIP_MAX_WIDTH_PX = 150;
export const CHIP_DATA_ATTRIBUTE = 'data-chip';
export const CHIP_SELECTOR = `[${CHIP_DATA_ATTRIBUTE}]`;
